import { type FC, type ReactNode, useState } from 'react'

import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { ExplotableItem } from 'modules/core/components/GroupingExplotable'

interface Props {
  level: { id: string; name: string }
  count: number
  children: ReactNode
}

const ExpandableGroup: FC<Props> = ({ level, count, children }) => {
  const [open, setOpen] = useState<boolean>(true)

  const handleToggle = () => {
    setOpen(!open)
  }

  return (
    <ExplotableItem
      key={level.id}
      bottomRadius={false}
      dropDownAnimated={false}
      expandIcon="caret"
      headerBorders={false}
      headerRounded={false}
      opened={open}
      renderHeader={() => (
        <Text.Normal size="200" weight="medium" color="grey800">
          {level.name} ({count})
        </Text.Normal>
      )}
      scrollLimited={false}
      size="small"
      toggle={handleToggle}
      type="primary"
    >
      {count > 0 && (
        <Table noRadius hideBorder>
          <Table.Body>{children}</Table.Body>
        </Table>
      )}
    </ExplotableItem>
  )
}

export default observer(ExpandableGroup)
